'''
Here 1 based indexing is used.
'''

<template>
    <div>
        <div v-if="loading">
            <div class="mt-base text-center">
                <font-awesome-icon :icon="loadingIcon" size="3x" class="mb-5" spin />
                <br />Loading Data.. Please wait..
            </div>
        </div>
        <div id="permission_edit" v-else>
            <h4>Role Permissions</h4>
            <vs-row class="mt-3 mb-4">
                <vs-col vs-xs="12" vs-sm="6" vs-lg="8" class="mb-3">
                    <vs-input v-model="permission_data.role" label="Role" class="w-full" :disabled="loading" />
                    <small class="block text-danger mt-1" v-if="api_errors && api_errors.role">
                        {{ api_errors.role.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="4" class="mb-3">
                    <label class="vs-input--label block">Is Active</label>
                    <div class="flex mt-3 align-center">
                        <vs-radio v-model="permission_data.is_active" vs-name="is_active" :vs-value="true"
                            :disabled="loading">Yes</vs-radio>
                        <vs-radio v-model="permission_data.is_active" vs-name="is_active" :vs-value="false" :disabled="loading"
                            class="mx-3">No</vs-radio>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors && api_errors.is_active">
                        {{ api_errors.is_active.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
            <!-- permission dropdown -->
            <vs-row>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                    <InputSelect
                        :model.sync="module_index"
                        label="Module Type"
                        placeholder="Choose ..."
                        container_class="w-auto input-custom-dropdown"
                        :options="module_options"
                        :multiple="false"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3" :key="module_index" v-if="module_index && submodule_options.length">
                    <InputSelect
                        :model.sync="submodule_index"
                        label="Sub Module Type"
                        placeholder="Choose ..."
                        container_class="w-auto input-custom-dropdown"
                        :options="submodule_options"
                        :multiple="false"
                    />
                </vs-col>
            </vs-row>
            <!-- permission card  -->
            <vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-base">
                    <vx-card v-if="permission_obj.enabled_permissions" 
                        :title="`${permission_obj.label}`" title-color="black" :collapse-action="true"
                    >
                        <vs-table :data="data" :hoverFlat="true" stripe>
                            <vs-tr>
                                <vs-th>Type</vs-th>
                                <vs-th v-if="!has_one">All</vs-th>
                                <vs-th v-if="!has_one">Own</vs-th>
                                <vs-th v-if="!has_one">Assigned</vs-th>
                                <vs-th v-if="has_one">Has Access</vs-th>
                            </vs-tr>
                            <!-- table data  -->
                            <vs-tr v-for="(key, key_index) in Object.keys(permission_obj.enabled_permissions)" :key="`${key}-${key_index}`">
                                <template v-if="Array.isArray(permission_obj.enabled_permissions[key])">
                                    <vs-td>
                                        {{ get_capitalize_key(key) }}
                                    </vs-td>
                                    <template v-if="has_one">
                                        <vs-td>
                                            <vs-checkbox
                                                :vs-value="`${key}__all__${permission_obj.code}`" v-model="permission_data.permissions"
                                                :disabled="loading"
                                            />
                                        </vs-td>
                                    </template>
                                    <template v-else>
                                        <vs-td>
                                            <template v-if="permission_obj.enabled_permissions[key].includes('all')">
                                                <vs-checkbox
                                                    :vs-value="`${key}__all__${permission_obj.code}`" v-model="permission_data.permissions"
                                                    :disabled="loading || permission_data.permissions.includes(`${key}__own__${permission_obj.code}`) || permission_data.permissions.includes(`${key}__assigned__${permission_obj.code}`)"
                                                />
                                            </template>
                                            <template v-else>
                                                -
                                            </template>
                                        </vs-td>
                                        <vs-td>
                                            <template v-if="permission_obj.enabled_permissions[key].includes('own')">
                                                <vs-checkbox
                                                    :vs-value="`${key}__own__${permission_obj.code}`" v-model="permission_data.permissions"
                                                    :disabled="loading || permission_data.permissions.includes(`${key}__all__${permission_obj.code}`)"
                                                />
                                            </template>
                                            <template v-else>
                                                -
                                            </template>
                                        </vs-td>
                                        <vs-td>
                                            <template v-if="permission_obj.enabled_permissions[key].includes('assigned')">
                                                <vs-checkbox
                                                    :vs-value="`${key}__assigned__${permission_obj.code}`" v-model="permission_data.permissions"
                                                    :disabled="loading || permission_data.permissions.includes(`${key}__all__${permission_obj.code}`)"
                                                />
                                            </template>
                                            <template v-else>
                                                -
                                            </template>
                                        </vs-td>
                                    </template>
                                </template>
                                <template v-else-if="key == 'resolution'">
                                    <vs-td colspan="4">
                                        <InputSelect
                                            :model.sync="resolution_type"
                                            label="Resolution Type"
                                            placeholder="Choose ..."
                                            container_class="w-auto input-custom-dropdown"
                                            :options="resolution_type_options"
                                            :multiple="false"
                                        />
                                        <vs-table class="mt-4" v-if="resolution_type" :data="Object.keys(permission_obj.enabled_permissions[key][resolution_type])" :hoverFlat="true" stripe>
                                            <vs-tr>
                                                <vs-th>Type</vs-th>
                                                <vs-th>All</vs-th>
                                                <vs-th>Assigned</vs-th>
                                            </vs-tr>
                                            <vs-tr v-for="(resolution_key, resolution_key_index) in Object.keys(permission_obj.enabled_permissions[key][resolution_type])" :key="`${key}-${resolution_key}-${resolution_key_index}`">
                                                <vs-td>
                                                    {{ get_capitalize_key(resolution_key) }}
                                                </vs-td>
                                                <vs-td>
                                                    <template v-if="permission_obj.enabled_permissions[key][resolution_type][resolution_key].includes('all')">
                                                        <vs-checkbox
                                                            :vs-value="`${resolution_key}__all__${permission_obj.code}`" v-model="permission_data.permissions"
                                                            :disabled="loading || permission_data.permissions.includes(`${resolution_key}__assigned__${permission_obj.code}`)"
                                                        />
                                                    </template>
                                                    <template v-else>
                                                        -
                                                    </template>
                                                </vs-td>
                                                <vs-td>
                                                    <template v-if="permission_obj.enabled_permissions[key][resolution_type][resolution_key].includes('assigned')">
                                                        <vs-checkbox
                                                            :vs-value="`${resolution_key}__assigned__${permission_obj.code}`" v-model="permission_data.permissions"
                                                            :disabled="loading || permission_data.permissions.includes(`${resolution_key}__all__${permission_obj.code}`)"
                                                        />
                                                    </template>
                                                    <template v-else>
                                                        -
                                                    </template>
                                                </vs-td>
                                            </vs-tr>
                                        </vs-table>
                                    </vs-td>
                                </template>
                            </vs-tr>
                        </vs-table>
                    </vx-card>
                </vs-col>
            </vs-row>
            <div class="text-center mt-base">
                <vs-button :disabled="!permission_data.permissions.length" type="filled" color="primary"
                    @click="save">Save</vs-button>
            </div>
        </div>
    </div>
</template>

<script>
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { Request } from '../../utils/requests';

export default {
    data() {
        return {

            data: [],
            module_index: null,
            submodule_index: null,
            resolution_type: null,

            permission_data: {
                id: null,
                role: null,
                is_active: true,
                permissions: [],
            },

            resolution_type_options: [
                {label: 'Internal', value: 'internal'}, 
                {label: 'External', value: 'external'}
            ],

            api_errors: {},
            loading: false,
        };
    },
    computed: {
        loadingIcon: () => faSpinner,
        module_options() {
            return this.data.map((obj, index) => {
                return {
                    label: obj.label,
                    value: index+1
                }
            })
        },
        submodule_options() {
            if (!this.module_index) return []
            if (!this.data[this.module_index-1].submodules) return []

            return this.data[this.module_index-1].submodules.map((obj, index) => {
                return {
                    label: obj.label,
                    value: index+1
                }
            })
        },
        permission_obj() {
            if (!this.module_index) return {}
            if (this.data[this.module_index - 1].submodules && !this.submodule_index) return {}

            return this.data[this.module_index - 1].submodules ? this.data[this.module_index - 1].submodules[this.submodule_index-1] :  this.data[this.module_index - 1]
        },
        has_one() {
            let data = Object.values(this.permission_obj.enabled_permissions)
            for(let i=0; i<data.length; i++) {
                console.log(data[i])
                console.log((data[i] instanceof Array))
                console.log((data[i].includes('own') || data[i].includes('assigned')))
                if ((data[i] instanceof Array) && (data[i].includes('own') || data[i].includes('assigned'))) {
                    return false
                }
            }
            return true
        }
    },
    watch: {
        module_index(newV, oldV) {
            if (newV==oldV) return
            this.submodule_index = null
        }
    },
    mounted() {
        this.role_permission_id = this.$route.params.role_permission_id
        if (this.role_permission_id) this.load_data()
        this.load_permission_data()
    },
    methods: {
        save() {
            this.$vs.loading();
            
            let request_method = 'POST', url = this.$store.state.apiendpoints.permission_role_create

            if (this.role_permission_id) {
                request_method = 'PUT'
                url += this.role_permission_id + '/'
            }

            Request(this, request_method, url, {}, this.permission_data).then(
                (res) => {
                    this.$vs.loading.close();
                    this.permission_data = res
                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved Successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    this.$router.push({name: 'list-role-permissions'})
                },
                (err) => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        time: 2500,
                        title: 'Error',
                        text: "Error Occured. Please try again later.",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.permission_role_create + this.role_permission_id + "/"

            this.loading = true;
            this.$vs.loading()

            Request(this, request_method, url).then(
                res => {
                    this.loading = false;
                    this.$vs.loading.close()
                    this.permission_data = res
                },
                err => {
                    this.loading = false;
                    this.$vs.loading.close()
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        load_permission_data() {

            this.loading = true;
            this.$vs.loading();

            let url = this.$store.state.apiendpoints.permission_data

            Request(this, 'GET', url, {}).then(
                (res) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    this.data = res
                },
                (err) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    this.$vs.notify({
                        time: 2500,
                        title: 'Error',
                        text: "Error Occured. Please try again later.",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        get_capitalize_key(key) {
            if (key.indexOf('_') !== -1) {
                return key.split("_").map((str, i) => str.charAt(0).toUpperCase() + str.slice(1)).join(" ")
            }
            return key.charAt(0).toUpperCase() + key.slice(1);
        }
    }
};
</script>

<style lang="scss">
#permission_edit {
    .vs-con-table .vs-con-tbody .con-vs-checkbox {
        -webkit-box-pack: start !important;
        justify-content: flex-start !important;
    }
}
</style>